import React from 'react';
import Link from 'gatsby-link';
import smoothscroll from 'smoothscroll-polyfill';

class Main extends React.Component {
  componentDidMount() {
    smoothscroll.polyfill();
    window.__forceSmoothScrollPolyfill__ = true;
  }

  render() {
    return (
      <div>
        <img
          className="bg-image-full"
          alt="Hatim Hakimjee"
          src="/img/background.jpg"
        />
        <div id="background-container" />
        <div id="container">
          <header id="top-section">
            <ul className="social-icons">
              <li>
                <a
                  title="Github"
                  href="https://github.com/hatimh"
                  target="_blank"
                >
                  <i className="fa fa-github" />
                </a>
              </li>
              <li>
                <a
                  title="LinkedIn"
                  href="https://ca.linkedin.com/in/hatimhakimjee"
                  target="_blank"
                >
                  <i className="fa fa-linkedin" />
                </a>
              </li>
            </ul>
          </header>
          <div id="left-sidebar">
            <div id="title">
              <h1>
                <a href="/">Hatim Hakimjee</a>
              </h1>
            </div>
            <div
              className="nav-menu"
            >
              <Link to="/">HOME</Link>
              <Link to="/about">ABOUT</Link>
              <Link to="/projects/mini-projects">MINI PROJECTS</Link>
              <Link to="/projects/cms-clients">CMS CLIENTS</Link>
              <Link to="/random">RANDOM</Link>
              <Link to="/services">SERVICES</Link>
              <Link to="/contact">CONTACT</Link>
            </div>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Main;
